export const CONTACT_PREFERRED_METHODS = ['email', 'phone', 'text'];
//# sourceMappingURL=contact-preferred-methods.js.map